var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { purgeDataset, undeleteDataset } from "@/api/datasets";
import { rethrowSimple } from "@/utils/simple-error";
const itemSizeSummaryFields = "id,name,size,deleted,archived";
export function fetchAllHistoriesSizeSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data: nonPurgedHistories, error: nonPurgedHistoriesError } = yield GalaxyApi().GET("/api/histories", {
            params: {
                query: {
                    keys: itemSizeSummaryFields,
                    q: ["deleted", "purged"],
                    qv: ["None", "false"],
                },
            },
        });
        if (nonPurgedHistoriesError) {
            rethrowSimple(nonPurgedHistoriesError);
        }
        const { data: nonPurgedArchivedHistories, error: nonPurgedArchivedHistoriesError } = yield GalaxyApi().GET("/api/histories/archived", {
            params: {
                query: {
                    keys: itemSizeSummaryFields,
                    q: ["purged"],
                    qv: ["false"],
                },
            },
        });
        if (nonPurgedArchivedHistoriesError) {
            rethrowSimple(nonPurgedArchivedHistoriesError);
        }
        const allHistoriesTakingStorageResponse = [
            ...nonPurgedHistories,
            ...nonPurgedArchivedHistories,
        ];
        return allHistoriesTakingStorageResponse;
    });
}
export function fetchHistoryContentsSizeSummary(historyId, limit = 5000, objectStoreId = null) {
    return __awaiter(this, void 0, void 0, function* () {
        const q = ["purged", "history_content_type"];
        const qv = ["false", "dataset"];
        if (objectStoreId) {
            q.push("object_store_id");
            qv.push(objectStoreId);
        }
        const { data, error } = yield GalaxyApi().GET("/api/datasets", {
            params: {
                query: {
                    history_id: historyId,
                    keys: itemSizeSummaryFields,
                    limit,
                    order: "size-dsc",
                    q: q,
                    qv: qv,
                },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function fetchObjectStoreContentsSizeSummary(objectStoreId, limit = 5000) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/datasets", {
            params: {
                query: {
                    keys: itemSizeSummaryFields,
                    limit,
                    order: "size-dsc",
                    q: ["purged", "history_content_type", "object_store_id"],
                    qv: ["false", "dataset", objectStoreId],
                },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function undeleteHistoryById(historyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().POST("/api/histories/deleted/{history_id}/undelete", {
            params: {
                path: { history_id: historyId },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function purgeHistoryById(historyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().DELETE("/api/histories/{history_id}", {
            params: {
                path: { history_id: historyId },
                query: { purge: true },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function undeleteDatasetById(datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield undeleteDataset(datasetId);
        return data;
    });
}
export function purgeDatasetById(datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield purgeDataset(datasetId);
        return data;
    });
}
